import { Box, Typography, makeStyles } from "@material-ui/core";
import * as React from "react";

import { layoutTokens as layout, semanticColors as colors, textStyles } from "@/designTokens";
import theme from "@/theme";

import ConsiderationImage from "@assets/image/property_management_v2/consideration-registration.png";
import OwnedImage from "@assets/image/property_management_v2/owned-registration.png";

import { CustomButton } from "../Button";

const useStyles = makeStyles({
  root: {
    minHeight: "calc(100vh - 160px)",
    padding: layout.space[24],
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    [theme.breakpoints.up("md")]: { minHeight: 480, padding: "48px 0" },
  },
  panel: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: layout.space[24],
    padding: "32px 24px",
    borderRadius: layout.radius.lg,
    background: colors["surface/card"],
    [theme.breakpoints.up("md")]: { width: 560, padding: "40px 48px" },
  },
  imageSlot: {
    width: 206,
    height: 120,
    position: "relative",
    overflow: "hidden",
    "& img": { position: "absolute", maxWidth: "none" },
  },
  owned: { width: "92.61%", height: "118.52%", top: "-8.29%", left: "3.53%" },
  consideration: { width: "100%", height: "129.03%", top: "-14.52%", left: 0 },
  texts: { display: "flex", flexDirection: "column", gap: layout.space[16], width: "100%" },
  title: {
    ...textStyles["SP/Heading/H3"],
    color: colors["text/primary"],
    textAlign: "center",
    [theme.breakpoints.up("md")]: { ...textStyles["PC/Heading/H3"] },
  },
  description: {
    ...textStyles["SP/Body/Large"],
    color: colors["text/secondary"],
    [theme.breakpoints.up("md")]: { ...textStyles["PC/Body/Large"] },
  },
  action: { width: "100%", [theme.breakpoints.up("md")]: { width: 360, maxWidth: "100%" } },
});

export const PropertyEmptyState: React.FC<{ type: "owned" | "consideration"; onClick: () => void }> = ({
  type,
  onClick,
}) => {
  const classes = useStyles();
  const consideration = type === "consideration";
  return (
    <Box className={classes.root}>
      <Box className={classes.panel}>
        <Box className={classes.imageSlot}>
          <img
            src={consideration ? ConsiderationImage : OwnedImage}
            alt=""
            className={consideration ? classes.consideration : classes.owned}
          />
        </Box>
        <Box className={classes.texts}>
          <Typography component="h2" className={classes.title}>
            {consideration ? "検討中の物件を登録しましょう" : "保有物件を登録しましょう"}
          </Typography>
          <Typography className={classes.description}>
            {consideration ? (
              <>
                登録すると、購入したあとの毎月の収支と、売却したときの手残りを試算できます。
                <br />
                提案された物件をそのまま入れて比べられます。
              </>
            ) : (
              "登録すると、毎月の収支と利回りが自動で計算され、売却したときの手残りまで見通せます。"
            )}
          </Typography>
        </Box>
        <CustomButton className={classes.action} onClick={onClick}>
          {consideration ? "検討中の物件を登録する" : "保有中の物件を登録する"}
        </CustomButton>
      </Box>
    </Box>
  );
};
